<template>
  <ModalContent>
    <ModalHeader @close="close">
      <ButtonBack @click="close" />

      {{ locale.selectCountries }}
    </ModalHeader>

    <ModalBody>
      <CountriesList
        v-model="selectedCountries"
        :countries="countries"
        :view-type="target.type.viewType"
      />
    </ModalBody>

    <ModalFooter>
      <ApplySettingsBtn @click="save"/>
    </ModalFooter>
  </ModalContent>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import ButtonBack from '@/components/ButtonBack.vue';
import CountriesList from './CountriesList.vue';
import ApplySettingsBtn from './ApplySettingsBtn.vue';

export default {
  components: {
    ButtonBack,
    CountriesList,
    ApplySettingsBtn,
  },
  props: {
    value: Array,
    countries: {
      type: Array,
      required: true,
    },
    target: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('config', [
      'locale',
    ]),
    ...mapState([
      'errors',
    ]),
    selectedCountries: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    save() {
      this.$emit('save');
    },
  },
};
</script>
